import { SAVE_CONFIGURATION } from 'store/actions/configurationAction'

export default function configurationReducer(
  state = {}, { type, payload } = {}
) {
  if (type === SAVE_CONFIGURATION) {
    return { ...state, ...payload }
  } else {
    return state
  }
}
